import React from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styles } from './mentions-a3b4fac3.js';
import cx from 'classnames';
import './style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MentionComponent = ({ children, mention, settings, theme }) => {
  const { onMentionClick, onMentionHover, getMentionLink } = settings;
  const mergedStyles = mergeStyles({ theme, styles });
  const ref = React.useRef(null);
  const onMouseOver = () => onMentionHover == null ? void 0 : onMentionHover(mention, ref.current);
  const onClick = () => onMentionClick == null ? void 0 : onMentionClick(mention);
  const onKeyDown = (e) => (e.key === "Enter" || e.key === " ") && onClick();
  const commonProps = {
    ref,
    onMouseOver,
    className: cx(mergedStyles.mention, theme.mentionPalette)
  };
  if (onMentionClick) {
    return /* @__PURE__ */ React.createElement("span", __spreadProps(__spreadValues({}, commonProps), { role: "link", tabIndex: 0, onKeyDown, onClick }), children);
  } else if (getMentionLink) {
    return /* @__PURE__ */ React.createElement("a", __spreadProps(__spreadValues({}, commonProps), { href: getMentionLink(mention), rel: "noopener noreferrer", tabIndex: 0 }), children);
  } else {
    return /* @__PURE__ */ React.createElement("span", __spreadValues({}, commonProps), children);
  }
};

export { MentionComponent as default };
//# sourceMappingURL=MentionComponent.js.map
